import { Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { FinancialyearService } from './financialyear.service';
import { BaseClass } from '../../utility/baseClass';
import { FinancialyearmodalComponent } from '../../directives/financialyearmodal/financialyearmodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-financialyear',
  templateUrl: './financialyear.component.html',
  styleUrls: ['./financialyear.component.css']
})
export class FinancialyearComponent extends BaseClass implements OnInit {
  @ViewChild('dt') dt: any;
  public tableData: any[] = [];
  excel_paragraph = '';
  public selectedItem: MenuItem | null = null;
  public commonScrollHeight = '';
  public searchText: string;
  public ref: DynamicDialogRef | undefined;
  public first2: number = 0;
  public rows2: number = 10;
  public totalRecords: number = 0;
  exceldownloadModal = false;
  public options = [];
  public paginatorArray = []; 
  public position = 'top';
  public cols = []; 
  public _selectedColumns = [];
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  message: GlobalMessage = new GlobalMessage();
  searchTerm: string = '';
  hasLimitedAccess = "";
  isSupportAdmin = "";
  isSupportLimited = "N";
  constructor(
    public router: Router,
    public dialogService: DialogService,
    public utilityservice: Utilityservice,
    private FinancialyearService: FinancialyearService,
    public PagehelpmodalService: PagehelpmodalService,
    public override injector: Injector 
  ) {
    super(injector);
    this.excel_paragraph = this.message.downloadexcel_text;
    this.utilityservice.configParams$.subscribe((data: any) => {
      const responseArray = data;
      if (responseArray) {
        const config = responseArray;
         this.hasLimitedAccess = config.haslimitedaccess; 
        this.isSupportAdmin = config.issupportadmin;
        if (this.hasLimitedAccess == "Y" && this.isSupportAdmin == "Y") {
          this.isSupportLimited = "Y";           
        }        
      } 
    });
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
    this.dynamiccols();
    this.utilityservice.getCSRFtoken();
    //this.getConfiguration();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'finyrid', header: 'ID', type: 'Number', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'finyr', header: 'Financial Year', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'createdby', header: 'Created By', type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'createdon', header: 'Created On', type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'activeflag', header: 'Status', type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ];
    this._selectedColumns = this.cols;
  }

getList() {
  const defaultRowsize = 10;

  this.FinancialyearService.getFinancialYearData().subscribe({
    next: (data: any[]) => {

      this.tableData = data.map(item => ({ ...item, isSelect: false }));

      this.totalRecords = this.tableData.length;
      this.tablecount = this.totalRecords;

      this.rowsize = this.totalRecords < defaultRowsize ? this.totalRecords : defaultRowsize;
      this.options = this.utilityservice.getOptionDropdown(this.totalRecords);
      this.paginatorArray = this.options.map(e => e.value);

      if (!this.paginatorArray.includes(this.rowsize)) {
        this.paginatorArray.push(this.rowsize);
      }

      this.paginatorArray = this.paginatorArray
        .filter(v => v <= this.totalRecords)
        .sort((a, b) => a - b);

      this.currentPageIndex = 0;
      setTimeout(() => {
        if (this.dt) {
          this.dt.first = this.currentPageIndex;
        }
      }, 0);

    },
    error: (error) => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error?.error || "Error",
        text: `This error occurred at: ${timestamp}`,
        icon: "error",
      });
    }
  });
}





  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Financial Year Data.xlsx", downloadapi: 'common/financialyear/getexceldata', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });

  }


  show(title, data) {
    let details = {};
    this.currentPageIndex = this.dt?.first || 0;
    if (title === 'Modify Financial Year') {
      this.FinancialyearService.getModify(data.finyrid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(FinancialyearmodalComponent, {
          header: title,
          width: '50vw',
          height: '40%',
          data: { title: title, datas: details,"hasLimitedAccess":this.isSupportLimited },
          contentStyle: {},
          baseZIndex: 10000,
        });
        this.ref.onClose.subscribe(() => {
          this.getList();
        });
      });
    } else {
      details = {};
      this.ref = this.dialogService.open(FinancialyearmodalComponent, {
        header: title,
        width: '50vw',
        height: '30%',
        data: { title: title, datas: details },
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  
  // getConfiguration(): void {
  //   this.FinancialyearService.getConfiguration().subscribe(
  //     (response) => {
  //       if (response && response.length > 0) {
  //         this.haslimitedAccess = response[0]?.haslimitedAccess; 
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching configuration:', error);
  //     }
  //   );
  // }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
 
}
